import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import User from './Pages/User.vue'
import Login from './components/Login.vue'
import Member from './Pages/Member.vue'
import Shop from './Pages/Shop.vue'
import Product from './Pages/Product.vue'
import Coupon from './Pages/Coupon.vue'
import Order from './Pages/Order.vue'
import OrderChange from './Pages/OrderChange.vue'
import OrderReturn from './Pages/OrderReturn.vue'
import Notice from './Pages/Notice.vue'
import Performance from './Pages/Performance.vue'
import Useperformance from './Pages/Useperformance.vue'
import MemberPoint from './Pages/Memberpoint.vue'
import Permission from './Pages/Permission.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'User',
      component: User,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        inLayout1: false,
        inLayout2: false
        
      }
    },
    {
      path: '/member',
      name: 'Member',
      component: Member,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true

      }
    },
    {
      path: '/shop',
      name: 'Shop',
      component: Shop,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true

      }
    },
    {
      path: '/product',
      name: 'Product',
      component: Product,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true

      }
    },
    {
      path: '/coupon',
      name: 'Coupon',
      component: Coupon,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true

      }
    },
    {
      path: '/order',
      name: 'Order',
      component: Order,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true

      }
    },
    {
      path: '/orderChange',
      name: 'orderChange',
      component: OrderChange,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true

      }
    },
    {
      path: '/notice',
      name: 'notice',
      component: Notice,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true

      }
    },
    {
      path: '/performance',
      name: 'performance',
      component: Performance,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true

      }
    },
    {
      path: '/userperformance',
      name: 'useperformance',
      component: Useperformance,
      meta: {
        inLayout1: false,
        inLayout2: true,
        requiresAuth: true
      }
    },
    {
      path: '/memberpoint',
      name: 'memberpoint',
      component: MemberPoint,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true

      }
    },
    {
      path: '/orderReturn',
      name: 'orderReturn',
      component: OrderReturn,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true

      }
    },
    {
      path: '/permission',
      name: 'Permission',
      component: Permission,
      meta: {
        inLayout1: true,
        inLayout2: true,
        requiresAuth: true

      }
    }
  ]
})

router.beforeEach((to, from, next) => {
 
  if (to.matched.some(record =>record.meta.requiresAuth)) {
     if (store.getters.isLoggedIn){
        next()
        return
     }
     
  }else {
    next()
  }
  
  const user =  JSON.parse(localStorage.getItem('user'))
  if (user != null) {
  if (user.role != 0) {
    if (to.path != '/userperformance' || to.path != '/shopperformance' && to.path != 'login') {
      next('/userperformance')  
    }else {
      next('/login')
    }
    
  }
  }else {
    next('/login')
  } 
 
})

export default router;